import React, { PureComponent } from "react";
import firebase from "../config/firebaseInit";
import swal from "sweetalert";
import Lieu, { Position, Reservation, Service, UserSend } from "../model/lieux";
import { Redirect } from "react-router-dom";
import $ from "jquery";

window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js').default; // pay attention to "default"
require('bootstrap/dist/js/bootstrap');



let congo = {
    bazzaville: [
        {
            name: "Makélékélé"
        },

        {
            name: "Centre ville"
        },

        {
            name: "Bacongo"
        },

        {
            name: "Poto-Poto"
        },

        {
            name: "Moungali"
        },

        {
            name: "Ouenzé"
        },

        {
            name: "Talangaï"
        },

        {
            name: "Mfilou"
        },

        {
            name: "Madibou"
        },

        {
            name: "Djiri"
        }
    ],
    pointenoire: [
        {
            name: "Lumumba"
        },
        {
            name: "Centre ville"
        },
        {
            name: "Mvoumvou"
        },
        {
            name: "Tié-Tié"
        },
        {
            name: "Loandjili"
        },
        {
            name: "Mongo-MPoukou"
        },
        {
            name: "Ngoyo"
        }
    ],
    bouenza: [
        {
            name: "Boko-Songho"
        },

        {
            name: "Kayes (district)"
        },

        {
            name: "Nkayi"
        },

        {
            name: "Bouansa"
        },

        {
            name: "Kingoué"
        },

        {
            name: "Mabombo"
        },

        {
            name: "Madingou"
        },


        {
            name: "Mfouati"
        },


        {
            name: "Mouyondzi"
        },


        {
            name: "Tsiaki"
        },

        {
            name: "Yamba"
        },
    ],
    kouilou: [
        {
            name: "Hinda"
        },

        {
            name: "Kakamoéka"
        },

        {
            name: "Madingo-kayes"
        },

        {
            name: "Mvouiti"
        },

        {
            name: "Nzambi"
        },

        {
            name: "Tchamba Nzassi"
        }

    ],
    plateaux: [
        {
            name: "Abala"
        },

        {
            name: "Allembé"
        },

        {
            name: "Djambala"
        },

        {
            name: "Gamboma"
        },

        {
            name: "Lékana"
        },

        {
            name: "Makotipoko"
        },

        {
            name: "Mbon"
        },

        {
            name: "Mpouya"
        },

        {
            name: "Mongolo"
        },

        {
            name: "Ngo"
        },

        {
            name: "Ollombo"
        },

        {
            name: "Ongoni"
        }
    ],
    lekoumou: [
        {
            name: "Bamabama"
        },
        {
            name: "Komono"
        },
        {
            name: "Mayéyé"
        },
        {
            name: "Sibiti"
        },
        {
            name: "Zanaga"
        }
    ],
    likouala: [
        {
            name: "Bétou"
        },
        {
            name: "Bouaniela"
        },
        {
            name: "Dongou"
        },
        {
            name: "Enyellé"
        },
        {
            name: "Epéna"
        },
        {
            name: "Impfondo"
        },
        {
            name: "Liranga"
        }
    ],
    pool: [
        {
            name: "Boko"
        },
        {
            name: "Goma Tsé Tsé"
        },
        {
            name: "Igné"
        },
        {
            name: "Kindamba"
        },
        {
            name: "Kinkala"
        },
        {
            name: "Kimba"
        },
        {
            name: "Louingui"
        },
        {
            name: "Loumo"
        },
        {
            name: "Mayama"
        },
        {
            name: "Mindouli"
        },
        {
            name: "Mbandza-Ndounga"
        },
        {
            name: "Ngabé"
        },
        {
            name: "Vindza"
        }
    ],
    niari: [
        {
            name: "Banda"
        },
        {
            name: "Divénié"
        },
        {
            name: "Kibangou"
        },
        {
            name: "Kimongo"
        },
        {
            name: "Londéla-Kayes"
        },
        {
            name: "Louvakou"
        },
        {
            name: "Mbindi"
        },
        {
            name: "Makabana"
        },
        {
            name: "Moungoundou Nord"
        },
        {
            name: "Moungoudou Sud"
        },
        {
            name: "Moutamba"
        },
        {
            name: "Mayoko"
        },
        {
            name: "Nyanga"
        },
        {
            name: "Yaya"
        }
    ],
    sangha: [
        {
            name: "Ouesso"
        },
        {
            name: "Pokola"
        },
        {
            name: "Ngbala"
        },
        {
            name: "Pikounda"
        },
        {
            name: "Sembé"
        },
        {
            name: "Souanké"
        }
    ],
    cuvetteouest: [
        {
            name: "Etoumbi"
        },
        {
            name: "Ewo"
        },
        {
            name: "Kéllé"
        },
        {
            name: "Mbama"
        },
        {
            name: "Mbomo"
        },
        {
            name: "Okoyo"
        }
    ],
    cuvette: [
        {
            name: "Boundji"
        },
        {
            name: "Loukoléla"
        },
        {
            name: "Makoua"
        },
        {
            name: "Mossaka"
        },
        {
            name: "Ngoko"
        },
        {
            name: "Ntokou"
        },
        {
            name: "Owando"
        },
        {
            name: "Oyo"
        },
        {
            name: "Tchikapika"
        }
    ],
}



function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}


class Formulaire extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            nom: '', prixMin: '', prixMax: '', adresseExact: '', adresseAprox: '', ville: "", contact: "",
            description: "", confirmer: false, arrondissement: [], selectedArrondisement: "", file: "", imageUrl: "",
            lat: "", long: "", categorie: "", photo: "", redirect: false,
            anonymous: false
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onTyping = this.onTyping.bind(this);
        this.fileInput = React.createRef();
    }


    componentDidMount() {

        /*    $("#loadMe").modal({
                 backdrop: "static",
                 keyboard: false,
                 show: true
             });
             setTimeout(function () {
                 $("#loadMe").modal("hide");
             }, 10000);*/

        firebase.auth().onAuthStateChanged((user) => {
            if (!user) {
                this.setState({ redirect: true });
            } else { $('#myModal').modal('show'); }
        });

        this.state.congo = congo;

        let lat = null;
        let long = null;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                lat = position.coords.latitude;
                long = position.coords.longitude;
                this.setState({ lat: lat, long: long });
            }, function () { });
        }

    }

    onTyping(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let arrond = [];

        if (!(target.type === 'checkbox')) {

            switch (value) {
                case "Bouenza":
                    arrond = congo.bouenza;
                    break;

                case "Kouilou":
                    arrond = congo.kouilou;
                    break;

                case "Plateaux":
                    arrond = congo.plateaux;
                    break;

                case "Lékoumou":
                    arrond = congo.lekoumou;
                    break;

                case "Pointe-Noire":
                    arrond = congo.pointenoire;
                    break;

                case "Likouala":
                    arrond = congo.likouala;
                    break;

                case "Brazzaville":
                    arrond = congo.bazzaville;
                    break;

                case "Pool":
                    arrond = congo.pool;
                    break;

                case "Niari":
                    arrond = congo.niari;
                    break;

                case "Sangha":
                    arrond = congo.sangha;
                    break;

                case "Cuvette-Ouest":
                    arrond = congo.cuvetteouest;
                    break;

                case "Cuvette":
                    arrond = congo.cuvette;
                    break;
            }

        }
        const name = target.name;
        this.setState({
            [name]: value
        });
        if (arrond.length > 0) {
            this.setState({
                arrondissement: arrond
            });
        }
    }
    onSubmit(event) {
        event.preventDefault();
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                $("#loadMe").modal({
                    backdrop: "static",
                    keyboard: false,
                    show: true
                });
            }
        });

        let db = firebase.firestore();
        let reference = firebase.storage().ref("images");
        reference = reference.child(this.state.nom);

        var fileReader = new FileReader();

        let self = this;

        fileReader.onload = function (event) {
            var image = new Image();

            image.onload = function () {
                var canvas = document.createElement("canvas");
                var context = canvas.getContext("2d");
                canvas.width = 516;
                canvas.height = 290;
                context.drawImage(image,
                    0,
                    0,
                    image.width,
                    image.height,
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );
                let file = dataURLtoFile(canvas.toDataURL());
                reference.put(file).then(() => {
                    console.log("ok upload");

                    reference.getDownloadURL().then((url) => {
                        self.setState({
                            photo: url
                        })

                        let docs = db.collection('lieux').doc();
                        if (!(self.state.nom.trim() === "" && self.state.adresseExact.trim() === ""
                            && self.state.adresseAprox.trim() === "" && self.state.ville.trim() === ""
                            && self.state.contact.trim() === "" && self.state.description.trim() === "" && !self.state.confirmer
                            && self.state.selectedArrondisement.trim() === "" && self.state.categorie.trim() === ""
                        )) {
                            let user = firebase.auth().currentUser;
                            if (user != null) {

                                let lieu = new Lieu(self.state.photo, self.state.nom, "", self.state.adresseExact
                                    , self.state.description
                                    , "", "", new Position(self.state.lat, self.state.long), new Reservation(self.state.contact, true),
                                    new Service([], []),
                                    "", self.state.contact, self.state.prixMin,
                                    self.state.prixMax, self.state.adresseAprox,
                                    self.state.ville, self.state.selectedArrondisement, new UserSend(
                                        user.photoURL,
                                        user.displayName
                                    ), self.state.categorie, self.state.anonymous);
                                let neWDocs = docs.set(JSON.parse(JSON.stringify(lieu)));
                                $("#loadMe").modal("hide");
                                swal({
                                    text: "LIEU RAJOUTE AVEC SUCCES",
                                    icon: "success",
                                })
                            } else {
                                $("#loadMe").modal("hide");
                                swal({
                                    text: "Veillez vous connectez",
                                    icon: "error",
                                })
                            }


                            self.setState(
                                {
                                    nom: "",
                                    prixMin: "",
                                    prixMax: "",
                                    adresseExact: "",
                                    adresseAprox: "",
                                    ville: "",
                                    contact: "",
                                    description: "",
                                    confirmer: false,
                                    selectedArrondisement: "",
                                    imageUrl: "",
                                    photo: ""
                                }
                            )
                        } else {
                            $("#loadMe").modal("hide");
                            swal({
                                text: "Veillez remplir tous les champs",
                                icon: "warning",
                            })
                        }


                        document.querySelector(".form").reset();

                    })
                });
            }
            image.src = event.target.result;

        };



        fileReader.readAsDataURL(this.fileInput.current.files[0]);

        return false;


    }


    render() {
        return (
            <React.Fragment>
                {this.state.redirect ? (<Redirect to="/profile" />) : (
                    <React.Fragment>
                        <div class="container">
                            <div class="modal fade" id="myModal">
                                <div class="modal-dialog modal-lg">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                            <h3 class="modal-title text-center"></h3>
                                            <h3 class="modal-title text-center">Etes-vous sur place ?</h3>
                                            <p style={{ textAlign: "center" }}> Afin d'aider les utilisateurs à facilement trouver les coins, Niochi récupère votre position GPS.</p>
                                            <p style={{ textAlign: "center" }}>Cela étant, nous vous demandons d'être sur place pendant l'ajout du coin. <br /> </p>
                                        </div>

                                        <div class="modal-footer text-center">
                                            <a href="" class="btn mx-auto btn-default text-center pull-middle" data-dismiss="modal" class="pagination-centered">Close</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="album">
                            <div className="container mt-45">
                                <div className="row">
                                    <div className="col-12">
                                        <h4>Enregister un établissement</h4>
                                        <p className="lead-mod">Votre position GPS sera prise, les utilisateurs auront accès à une carte pour s'y rendre.</p>

                                        <form method="POST" className="form" >
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label for="inputEmail4">Nom de l'établissement</label>
                                                    <input required type="text" className="form-control" name="nom" id="inputEmail4" onChange={this.onTyping} value={this.state.nom} placeholder="Nom de l'établissement" />
                                                </div>

                                                <div className="form-group col-md-6">
                                                    <label for="exampleFormControlTextarea1">Categorie</label>
                                                    <select id="inputState" required value={this.state.categorie} name="categorie" onChange={this.onTyping} className="form-control">
                                                        <option value="">Choisir...</option>
                                                        <option value="restaurant">Restaurant</option>
                                                        <option value="bar">Bar</option>
                                                        <option value="nganda">Nganda</option>
                                                        <option value="boite de nuit">Boite de nuit</option>
                                                        <option value="vip">VIP</option>
                                                        <option value="hotel">hotel</option>
                                                        <option value="mini hotel">Mini Hotel</option>
                                                    </select>
                                                </div>

                                                <div className="form-group col-md-6">
                                                    <label for="inputEmail4">Contact</label>
                                                    <input required type="number" className="form-control" value={this.state.contact} onChange={this.onTyping} name="contact" id="inputEmail4" placeholder="Téléphone" />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label for="inputPassword4">Adresse exacte</label>
                                                    <input required type="text" className="form-control" name="adresseExact" onChange={this.onTyping} value={this.state.adresseExact} id="inputAddress1" placeholder="12 rue louomo" />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label for="inputAddress">Addresse approximative</label>
                                                    <input required type="text" className="form-control" name="adresseAprox" onChange={this.onTyping} value={this.state.adresseAprox} id="inputAddress2" placeholder="Vers la mairie de Ouenzé" />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label for="inputPassword4">Ville</label>
                                                    <select id="inputState" required value={this.state.ville} name="ville" onChange={this.onTyping} className="form-control">
                                                        <option value="">Choisir...</option>
                                                        <option value="Bouenza">Bouenza</option>
                                                        <option value="Kouilou">Kouilou</option>
                                                        <option value="Plateaux">Plateaux</option>
                                                        <option value="Pointe-Noire">Pointe-Noire</option>
                                                        <option value="Lékoumou">Lékoumou</option>
                                                        <option value="Likouala">Likouala</option>
                                                        <option value="Brazzaville">Brazzaville</option>
                                                        <option value="Pool">Pool</option>
                                                        <option value="Niari">Niari</option>
                                                        <option value="Sangha">Sangha</option>
                                                        <option value="Cuvette-Ouest">Cuvette-Ouest</option>
                                                        <option value="Cuvette">Cuvette</option>
                                                    </select>
                                                </div>

                                                <div className="form-group col-md-6">
                                                    <label for="inputPassword4">Quartier du coin</label>
                                                    <select id="inputState" name="selectedArrondisement" onChange={this.onTyping} value={this.state.selectedArrondisement} className="form-control">
                                                        <option value="">Choisir...</option>

                                                        {this.state.arrondissement.length > 0 && this.state.arrondissement.map((item) => {
                                                            return <option value={item.name} key={item.name}>{item.name}</option>;
                                                        })}

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label for="exampleFormControlTextarea1">Description de l'établissement</label>
                                                    <textarea className="form-control" name="description" value={this.state.description} onChange={this.onTyping} id="exampleFormControlTextarea1" rows="3"></textarea>
                                                </div>
                                                <form-group className="col-md-6">
                                                    <label for="exampleFormControlFile1">Image de l'établissement</label>
                                                    <input type="file" ref={this.fileInput} value={this.state.imageUrl}
                                                        className="form-control-file" id="exampleFormControlFile1"
                                                        accept="image/*"
                                                        name="imageUrl"
                                                        onChange={this.onTyping}
                                                    />
                                                </form-group>
                                            </div>

                                            <div className="form-group mt-3">
                                                <div className="form-check">
                                                    <input className="form-check-input" name="confirmer" value={this.state.confirmer} onChange={this.onTyping} type="checkbox" id="gridCheck" />
                                                    <label className="form-check-label" for="gridCheck">
                                                        Je confirme que les informations rentrées sont correctes
                        </label>
                                                </div>

                                                <div className="form-check">
                                                    <input className="form-check-input" name="anonymous" value={this.state.anonymous} onChange={this.onTyping} type="checkbox" id="anonymous" />
                                                    <label className="form-check-label" for="anonymous">
                                                        Rester anonyme
                        </label>
                                                </div>
                                            </div>
                                            <button onSubmit={this.onSubmit} onClick={this.onSubmit} className="btn btn-primary">Soumettre</button>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal fade" id="loadMe" tabindex="-1" role="dialog" aria-labelledby="loadMeLabel">
                            <div class="modal-dialog modal-sm" role="document">
                                <div class="modal-content">
                                    <div class="modal-body text-center">
                                        <div class="loader"></div>
                                        <div clas="loader-txt">
                                            <p>Votre formulaire est en cours d'envoi. <br /><br /><small>Ce coin va certainement aider un autre utilisateur dans le besoin.</small></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> </React.Fragment>

                )}
            </React.Fragment>

        );
    }
}
export default Formulaire;